export type Locale = "he" | "en";
export type Theme = "light" | "dark";

export const LOCALES: { id: Locale; country: string; abbr: string }[] = [
  { id: "he", country: "IL", abbr: "HE" },
  { id: "en", country: "US", abbr: "EN" },
];

export const LOCALE_KEY = "chatisafe-locale";
export const THEME_KEY = "chatisafe-theme";

const he = {
  nav: {
    how: "איך זה עובד",
    protection: "הגנה",
    plans: "תמחור",
    login: "התחברות",
    logout: "התנתקות",
    startFree: "התחלה חינם",
    dashboard: "לוח בקרה",
    themeLight: "מצב בהיר",
    themeDark: "מצב כהה",
    language: "שפה",
    openMenu: "פתיחת תפריט",
    closeMenu: "סגירת תפריט",
  },
  footer: {
    tagline: "הגנת וואטסאפ שנבנתה למשפחות. ₪15 לילד — בלי כאבי ראש.",
    privacy: "פרטיות",
    terms: "תנאים",
    accessibility: "הצהרת נגישות",
  },
  a11y: {
    button: "נגישות",
    title: "תפריט נגישות",
    close: "סגירה",
    fontSize: "גודל טקסט",
    increase: "הגדלה",
    decrease: "הקטנה",
    contrast: "ניגודיות גבוהה",
    grayscale: "גווני אפור",
    links: "הדגשת קישורים",
    readable: "גופן קריא",
    spacing: "ריווח טקסט",
    motion: "עצירת אנימציות",
    cursor: "סמן גדול",
    focus: "הדגשת מיקוד מקלדת",
    reset: "איפוס הגדרות",
    statement: "הצהרת נגישות",
    skip: "דילוג לתוכן הראשי",
  },
  landing: {
    h1: "הגנת וואטסאפ שעובדת בשקט — כדי שהילד שלך יוכל פשוט להיות ילד.",
    lead: "מחברים את הוואטסאפ של הילד בפחות מדקה. צ'אטיסייף סורק בריונות, איומים ותוכן לא הולם, ומתריע לכם — בלי להפוך אתכם למרגלים במשרה מלאה.",
    cta: "הגנו על הילד",
    seeHow: "איך זה עובד",
    setup: "התקנה ב־60 שניות · חיבור מאובטח לוואטסאפ · סריקה עם פרטיות קודם",
    reality: "המציאות",
    realityH2: "וואטסאפ לא נבנה לילדים.",
    realityP: "הילד צריך אותו כדי להישאר מחובר. אתם צריכים לישון. שני הדברים מתנגשים כל לילה.",
    pain1t: "בריונות והדרה",
    pain1b: "הוצאות מקבוצות והודעות פוגעניות משאירות סימנים שההורים לא רואים בזמן.",
    pain2t: "איומים וזרים",
    pain2b: "מספרים לא מוכרים ולחץ מופיעים הרבה לפני שילד יודע איך להגיב.",
    pain3t: "מדיה לא הולמת",
    pain3b: "תמונות וסרטונים מגיעים בלי אזהרה — ונעלמים לפני שמישהו שואל.",
    how: "איך זה עובד",
    howH2: "מגדירים פעם אחת. נשארים מוגנים.",
    step1t: "יוצרים חשבון הורה",
    step1b: "נרשמים ומוסיפים את הילד הראשון — 3 ימי ניסיון חינם, בלי כרטיס.",
    step2t: "סורקים את ה־QR של וואטסאפ",
    step2b: "מתחילים חיבור הגנה ומקשרים דרך מכשירים מקושרים — בלי כרום ברקע.",
    step3t: "ההגנה רצה בשקט",
    step3b: "הודעות נכנסות נסרקות. אתם מקבלים התראות. הילד ממשיך לשוחח.",
    prot: "הגנה",
    protH2: "הגנה חכמה להורים — ממוקדת, פשוטה וברורה.",
    f1t: "התראות איומים ובריונות",
    f1b: "ההורה מקבל התראה כשמופיעים דפוסים מסוכנים.",
    f2t: "סריקה עם פרטיות קודם",
    f2b: "מתמקדים בתעבורה נכנסת. אפשר להסתיר גוף הודעה בהתראות.",
    f3t: "₪15 לילד. וזהו.",
    f3b: "בלי תוכניות ובלי מדרגות — כל ילד ₪15 ל־30 יום, וכל הילדים מלוח בקרה אחד.",
    f4t: "אותות הדרה מקבוצה",
    f4b: "תופסים הוצאות ודפוסי הדרה מוקדם.",
    f5t: "חיבורי הגנה לוואטסאפ",
    f5b: "פרוטוקול מולטי־דיווייס מקורי. QR + קוד קישור. בלי כרום חסר־ראש.",
    f6t: "פילטרים שאתם שולטים בהם",
    f6b: "התעלמות מהודעות עצמיות, דיווחי חסימה, כללי מדיה — מכוון להורות אמיתית.",
    ctaH2: "הגנו על הילד תוך דקות.",
    ctaP: "הילד הראשון ב־3 ימי ניסיון חינם. אחר כך ₪15 לילד ל־30 יום — חצי שקל ליום. ישנים קצת יותר טוב הלילה.",
    startTrial: "התחילו ניסיון חינם",
    viewPlans: "לתמחור",
    pricing: "תמחור",
    pricingH2: "בלי כאבי ראש. פשוט ₪15 לילד.",
    pricingP:
      "בלי תוכניות, בלי מדרגות ובלי אותיות קטנות. כל ילד — ₪15 ל־30 יום. זה חצי שקל ליום על שקט נפשי.",
    pricingPrice: "₪15",
    pricingUnit: "לילד · ל־30 יום",
    pricingPerDay: "= ₪0.50 ליום",
    pricingPoints: [
      "הילד הראשון — 3 ימי ניסיון חינם, בלי כרטיס אשראי",
      "כל ילד נוסף — ₪15 ל־30 יום, מהרגע הראשון",
      "חידוש אוטומטי או תשלום חד־פעמי — אתם מחליטים",
      "ביטול בכל רגע. בלי התחייבות, בלי הפתעות",
    ],
    pricingCta: "מתחילים בניסיון חינם",
  },
  hero: {
    linked: "מכשיר מקושר",
    protected: "מוגן",
    group: "צ'אט קבוצתי",
    groupD: "זוהה דפוס הדרה",
    unknown: "שולח לא מוכר",
    unknownD: "נחסם לפני מסירה",
    media: "הודעת מדיה",
    mediaD: "סומן · ההורה קיבל התראה",
    session: "חיבור הגנה",
    live: "חי · סורק הודעות נכנסות",
    parent: "התראת הורה",
    parentD: "שפת בריונות נחסמה",
    child: "חוויית הילד",
    childD: "וואטסאפ רגיל",
  },
  auth: {
    welcome: "ברוכים השבים",
    loginLead: "התחברו כדי לנהל סשני הגנה.",
    email: "אימייל",
    password: "סיסמה",
    confirmPassword: "אימות סיסמה",
    passwordMismatch: "הסיסמאות לא תואמות",
    signingIn: "מתחברים...",
    login: "התחברות",
    newHere: "חדשים כאן?",
    createAccount: "צרו חשבון",
    loginFailed: "ההתחברות נכשלה",
    registerTitle: "יוצרים חשבון",
    registerParent: "הורה",
    registerLead: "אחר כך בוחרים תוכנית ומקשרים את הוואטסאפ של הילד.",
    fullName: "שם מלא",
    phone: "טלפון",
    creating: "יוצרים...",
    create: "צרו חשבון",
    haveAccount: "כבר יש חשבון?",
    registerFailed: "ההרשמה נכשלה",
    continueRegister: "המשך להרשמה",
    sendingCode: "שולחים קוד...",
    verifyEmailTitle: "אימות אימייל",
    verifyEmailLead: "שלחנו קוד לכתובת",
    verificationCode: "קוד אימות",
    verifying: "מאמתים...",
    confirmEmail: "אימות ויצירת חשבון",
    wrongEmailBack: "לא האימייל הנכון? חזרה לדף ההרשמה",
    emailTaken: "האימייל כבר רשום",
    mailNotConfigured: "שליחת מייל לא מוגדרת בשרת",
    codeSendFailed: "שליחת הקוד נכשלה",
    duplicateSend: "נשלח כבר — המתינו רגע ונסו שוב",
    invalidCode: "קוד שגוי",
    codeExpired: "הקוד פג תוקף — נסו שוב מההתחלה",
    tooManyAttempts: "יותר מדי ניסיונות — נסו שוב מאוחר יותר",
    verificationExpired: "ההרשמה פגה — התחילו מחדש",
    forgotPassword: "שכחתי סיסמה",
    forgotTitle: "איפוס סיסמה",
    forgotLeadEmail: "הזינו האימייל שאיתו נרשמתם. נשלח לשם קוד אימות.",
    sendResetCode: "שליחת קוד",
    forgotCodeLead: "הזינו את הקוד שנשלח לאימייל.",
    noEmailAccess: "אין לי גישה לאימייל שנרשמתי איתו",
    parentPhoneLead: "הזינו מספר טלפון של אחד ההורים הרשומים בחשבון. נשלח קוד בוואטסאפ.",
    parentPhone: "טלפון הורה",
    sendParentCode: "שליחת קוד לוואטסאפ",
    parentCodeLead: "הזינו את הקוד שנשלח לוואטסאפ של ההורה.",
    parentPhoneMismatch: "מספר הטלפון לא תואם להורה בחשבון",
    invalidPhone: "מספר טלפון לא תקין",
    reporterOffline: "שירות ההתראות לא זמין כרגע",
    backToEmailReset: "חזרה לאיפוס באימייל",
    backToLogin: "חזרה להתחברות",
    continue: "המשך",
    resetFailed: "איפוס הסיסמה נכשל",
    newPasswordTitle: "סיסמה חדשה",
    newPasswordLead: "בחרו סיסמה חדשה לחשבון.",
    newPassword: "סיסמה חדשה",
    savingPassword: "שומרים...",
    saveAndLogin: "שמירה והתחברות",
    resetSessionExpired: "פג תוקף האיפוס — התחילו שוב מתהליך שכחתי סיסמה",
    loading: "טוען...",
  },
  billing: {
    tagline: "בלי כאבי ראש. פשוט ₪15 לילד.",
    taglineSub: "בלי תוכניות, בלי מדרגות ובלי אותיות קטנות. כל ילד — ₪15 ל־30 יום. חצי שקל ליום.",
    perChild: "₪15 לילד",
    per30: "ל־30 יום",
    perDay: "₪0.50 ליום",
    trialBadge: "הילד הראשון — 3 ימי ניסיון חינם",
    trialExplain:
      "הילד הראשון שתוסיפו מקבל 3 ימי ניסיון חינם, בלי כרטיס אשראי. בסיום הניסיון ההגנה תושהה עד לתשלום של ₪15 ל־30 יום (₪0.50 ליום).",
    paidExplain:
      "כל ילד נוסף מחויב מיד ב־₪15 ל־30 יום — חצי שקל ליום. בוחרים חידוש אוטומטי או תשלום חד־פעמי.",
    addChildTitle: "הוספת ילד",
    addFirstChildTitle: "הוספת הילד הראשון — ניסיון חינם",
    childNameLabel: "שם הילד (כפי שמופיע בקבוצות)",
    startTrialBtn: "התחילו 3 ימי ניסיון חינם",
    payAndAdd: "תשלום ₪15 והוספת הילד",
    payRenew: "תשלום ₪15 ל־30 יום",
    payTitle: "הפעלת הגנה ל־{name}",
    summaryTitle: "סיכום חיוב",
    lineChild: "הגנה ל־{name} · 30 יום",
    lineTotal: "לתשלום היום",
    autoRenewLabel: "חידוש אוטומטי כל 30 יום (₪15)",
    autoRenewHint: "אפשר לכבות בכל רגע. בלי חידוש אוטומטי — ההגנה תושהה בתום 30 הימים עד לתשלום הבא.",
    oneTimeHint: "תשלום חד־פעמי: ההגנה פעילה 30 יום ומסתיימת בלי חיוב נוסף.",
    cardName: "שם על הכרטיס",
    cardNumber: "מספר כרטיס",
    expiry: "תוקף (MM/YY)",
    cvc: "CVC",
    demoNote: "שער תשלום לדוגמה — כל כרטיס תקין עובד חוץ ממספר שמסתיים ב־0000.",
    processing: "מעבדים…",
    cancel: "ביטול",
    stTrial: "ניסיון חינם · נותרו {days} ימים",
    stTrialEnds: "בסיום הניסיון ({date}) נדרש תשלום של ₪15 ל־30 יום כדי להמשיך",
    stActive: "מוגן עד {date}",
    stActiveDays: "נותרו {days} ימים",
    stAutoOn: "חידוש אוטומטי פעיל — ₪15 יחויבו ב־{date}",
    stAutoOff: "ללא חידוש אוטומטי — ההגנה תושהה ב־{date}",
    stExpired: "ההגנה מושהית — התקופה הסתיימה",
    stExpiredHint: "ההודעות של {name} לא נסרקות ולא נשלחות התראות עד להסדרת התשלום.",
    stNone: "אין תקופת הגנה פעילה",
    payNowBtn: "תשלום ₪15",
    extendBtn: "הארכה ב־30 יום (₪15)",
    autoOn: "הפעלת חידוש אוטומטי",
    autoOff: "כיבוי חידוש אוטומטי",
    sectionTitle: "חיוב ותשלומים",
    sectionLead: "₪15 לילד ל־30 יום. חצי שקל ליום. בלי כאבי ראש.",
    activeChildren: "ילדים מוגנים",
    monthlyTotal: "סה״כ ל־30 יום",
    cardOnFile: "כרטיס שמור",
    noCard: "אין כרטיס שמור",
    renewalFailed: "החידוש האחרון נכשל — שלמו ידנית כדי לעדכן כרטיס",
    historyTitle: "היסטוריית תשלומים",
    historyEmpty: "עדיין אין תשלומים",
    hDate: "תאריך",
    hChild: "ילד",
    hDesc: "פירוט",
    hPeriod: "תקופה",
    hAmount: "סכום",
    hStatus: "סטטוס",
    hOrder: "מזהה עסקה",
    kindTrial: "ניסיון חינם (3 ימים)",
    kindPurchase: "הוספת ילד · 30 יום",
    kindRenewal: "חידוש · 30 יום",
    statusOk: "הצליח",
    statusDeclined: "נדחה",
    errCard: "מספר כרטיס לא תקין",
    errExpiry: "תוקף לא תקין (MM/YY)",
    errExpired: "הכרטיס פג תוקף",
    errDeclined: "הכרטיס נדחה (בדמו: כל מספר שלא מסתיים ב־0000)",
    errNoCard: "אין כרטיס שמור — שלמו פעם אחת כדי לשמור כרטיס",
    errTrialUsed: "הניסיון כבר נוצל — הוספת ילד כרוכה בתשלום ₪15",
    errPaymentRequired: "נדרש תשלום כדי להפעיל הגנה לילד הזה",
    errGeneric: "משהו השתבש — נסו שוב",
    headerChip: "{n} ילדים מוגנים · ₪15 לילד",
    headerChipNone: "₪15 לילד · הילד הראשון בניסיון חינם",
    attention: "{n} ילדים ממתינים לתשלום — ההגנה עליהם מושהית",
  },
  legal: {
    privacy: "מדיניות פרטיות",
    terms: "תנאי שימוש",
    accessibility: "הצהרת נגישות",
    back: "חזרה",
    updated: "עודכן לאחרונה: {date}",
    toc: "תוכן העניינים",
    print: "הדפסה",
  },
  dash: {
    signedIn: "מחוברים כ־{email}",
    hey: "היי {name}",
    billingUnavailable: "לא ניתן לטעון את מצב החיוב כרגע — נסו לרענן",
    children: "ילדים",
    childPlaceholder: "שם התצוגה של הילד (כמו בקבוצות)",
    addChild: "הוספת ילד",
    editChildName: "עריכת שם",
    saveChildName: "שמירה",
    renameFail: "עדכון השם נכשל",
    noChildren: "אין עדיין ילדים. הוסיפו את הילד הראשון — 3 ימי ניסיון חינם — ואז מקשרים וואטסאפ עם QR.",
    on: "ההגנה פעילה",
    linkedPaused: "מקושר · ההגנה מושהית",
    noNumber: "המספר לא זמין — הפעילו הגנה",
    waitingScan: "ממתינים לסריקת וואטסאפ…",
    notLinked: "לא מקושר",
    pause: "השהיה",
    start: "הפעלת הגנה",
    unlink: "ניתוק",
    cancelPair: "ביטול קישור",
    linkWa: "קישור וואטסאפ",
    mockQr: "QR דמו — לא ניתן לסריקה בוואטסאפ אמיתי.",
    qrHint: "וואטסאפ → מכשירים מקושרים → קישור מכשיר",
    waitingQr: "ממתינים ל־QR…",
    mockScan: "פיתוח: סימולציית סריקה",
    orCode: "או קוד קישור",
    phonePh: "טלפון הילד ב־E.164",
    getCode: "קבלת קוד",
    settings: "הגדרות הגנה",
    settingsLead:
      "קבעו אילו אירועים וסוגי תוכן יישלחו להורים המאומתים בוואטסאפ. כל האפשרויות פעילות כברירת מחדל; בטלו רק מה שאינכם רוצים לקבל.",
    secBlock: "דיווחי רשימת חסימה",
    secBlockDesc: "התראות כשהילד/ה חוסם/ת או מסיר/ה חסימה מאיש קשר בוואטסאפ.",
    reportBlock: "דיווח על חסימת משתמש",
    reportUnblock: "דיווח על הסרת חסימה ממשתמש",
    secGroups: "דיווחים מקבוצות",
    secGroupsDesc: "אירועי קבוצה והודעות בקבוצה שבהן הילד/ה מוזכר/ת או מצוטט/ת.",
    reportGroupRemoval: "דיווח על הסרה מקבוצה",
    reportGroupJoin: "דיווח על הצטרפות לקבוצה",
    reportGroupHarmful:
      "דיווח על הודעות בעלות תוכן בלתי הולם בקבוצה, כאשר הילד/ה מצוטט/ת או מוזכר/ת בהן",
    secPrivate: "דיווחים מצ'אטים פרטיים",
    secPrivateDesc: "התראות על פעילות ממספרים שאינם שמורים באנשי הקשר של הילד/ה.",
    reportUnknownContact:
      "דיווח על הודעות ממספרי טלפון לא מוכרים (הודעות מזרים) — רק ההודעה הראשונה והשנייה בצ'אט",
    secGeneral: "דיווחים כלליים",
    secGeneralDesc: "סינון לפי סוג מדיה, פרטיות תוכן ההתראה, והודעות יוצאות מהילד/ה.",
    mediaTypes: "סוגי הודעות לדיווח",
    reportMediaImages: "תמונות",
    reportMediaVideos: "סרטונים",
    reportMediaAudio: "הקלטות קול",
    reportMediaText: "הודעות טקסט",
    reportMediaStickers: "סטיקרים",
    privacyMode: "תצוגת תוכן בהתראות",
    privacyShowContent: "הצגת תוכן ההודעות המדווחות",
    privacyHideContent: "שמירת פרטיות הילד/ה — רק סוג ההודעה וסוג התוכן",
    privacyHideHint:
      "במצב פרטיות לא יישלחו ציטוטים, תמונות או הקלטות בהתראה; תקבלו תיאור כללי של סוג האירוע.",
    reportOutgoing: "הצגת דיווחים על הודעות יוצאות שהילד/ה שלח/ה",
    reportOutgoingHint: "כולל תוכן בלתי הולם שהילד/ה שלח/ה לאחרים, לפי סוגי המדיה שסומנו למעלה.",
    addFail: "הוספת הילד נכשלה",
    startFail: "ההפעלה נכשלה",
    unlinkConfirm: "לנתק וואטסאפ? זה מסיר את המכשיר ממכשירים מקושרים.",
    unlinkFail: "הניתוק נכשל — המכשיר לא הוסר מוואטסאפ",
    deleteLinked: "למחוק את הילד? קודם ינותק הוואטסאפ ממכשירים מקושרים.",
    deletePlain: "למחוק את הילד מצ'אטיסייף?",
    deleteFail: "המחיקה נכשלה",
    pairFail: "הקישור נכשל",
    qrFail: "ה־QR נכשל — לחצו שוב על התחלה",
    parents: "הורים",
    parentsLead: "הוסיפו הורה שיקבל דיווחים בוואטסאפ על הודעות חשודות. נדרש אימות מספר לפני שמקשרים ילדים.",
    addParent: "הוספת הורה",
    parentName: "שם ההורה",
    parentPhone: "מספר טלפון",
    parentCountry: "מדינה",
    parentSendCode: "שליחת קוד אימות",
    parentVerifyLead: "שלחנו קוד בוואטסאפ. הזינו אותו כאן כדי לאשר את המספר.",
    parentCode: "קוד אימות",
    parentConfirm: "אישור והוספה",
    parentResend: "שליחה מחדש",
    parentRemove: "הסרה",
    parentRemoveConfirm: "להסיר את ההורה מרשימת הדיווחים?",
    parentInvalidPhone: "מספר טלפון לא תקין.",
    parentNotOnWa: "מספר זה לא רשום בוואטסאפ.",
    parentReporterOffline: "שירות הדיווח לא מחובר — נסו שוב מאוחר יותר.",
    parentAlready: "המספר כבר ברשימה.",
    parentWrongCode: "קוד שגוי.",
    parentCodeExpired: "הקוד פג תוקף — שלחו קוד חדש.",
    parentSendFail: "שליחת הקוד נכשלה.",
    parentGenericFail: "הפעולה נכשלה.",
    parentServerError: "שגיאת שרת — נסו שוב בעוד רגע.",
    parentWaCheckFail: "לא ניתן לבדוק את המספר בוואטסאפ. ודאו שה־Reporter מחובר.",
    parentWaServiceOutdated: "שירות ההתראות לא זמין כרגע. נסו שוב מאוחר יותר.",
    parentNoPending: "אין בקשת אימות פעילה — שלחו קוד מחדש.",
    parentTooManyAttempts: "יותר מדי ניסיונות — שלחו קוד חדש.",
    childrenLocked: "הוסיפו ואמתו לפחות הורה אחד כדי לנהל ילדים.",
  },
  admin: {
    title: "אדמין",
    password: "סיסמת אדמין",
    enter: "כניסה",
    wrong: "סיסמה שגויה",
    users: "משתמשים",
    payments: "תשלומים",
    sessions: "סשנים",
    logout: "יציאה",
    all: "הכל",
    paying: "משלמים",
    notPaying: "לא משלמים",
    noUsers: "אין משתמשים",
    noSessions: "אין סשנים",
    noPayments: "אין משלמים",
    name: "שם",
    email: "אימייל",
    phone: "טלפון",
    plan: "תוכנית",
    none: "אין",
    child: "ילד",
    session: "סשן",
    waPhone: "מספר מחובר",
    notConnected: "לא מחובר",
    running: "רץ",
    stopped: "לא רץ",
    connected: "מחובר",
    owner: "משתמש",
    registered: "נרשם",
    expires: "תפוגה",
    count: "{n} משתמשים",
  },
};

const en = {
  nav: {
    how: "How it works",
    protection: "Protection",
    plans: "Pricing",
    login: "Log in",
    logout: "Log out",
    startFree: "Start free",
    dashboard: "Dashboard",
    themeLight: "Light mode",
    themeDark: "Dark mode",
    language: "Language",
    openMenu: "Open menu",
    closeMenu: "Close menu",
  },
  footer: {
    tagline: "WhatsApp protection built for families. ₪15 per child — no headaches.",
    privacy: "Privacy",
    terms: "Terms",
    accessibility: "Accessibility statement",
  },
  a11y: {
    button: "Accessibility",
    title: "Accessibility menu",
    close: "Close",
    fontSize: "Text size",
    increase: "Increase",
    decrease: "Decrease",
    contrast: "High contrast",
    grayscale: "Grayscale",
    links: "Highlight links",
    readable: "Readable font",
    spacing: "Text spacing",
    motion: "Stop animations",
    cursor: "Large cursor",
    focus: "Keyboard focus highlight",
    reset: "Reset settings",
    statement: "Accessibility statement",
    skip: "Skip to main content",
  },
  landing: {
    h1: "WhatsApp protection that watches quietly — so your kid can just be a kid.",
    lead: "Link your child's WhatsApp in under a minute. ChatiSafe scans for bullying, threats, and inappropriate content, then alerts you — without turning you into a full-time spy.",
    cta: "Protect your child",
    seeHow: "See how it works",
    setup: "Setup in 60 seconds · Secure WhatsApp linking · Privacy-first scanning",
    reality: "The reality",
    realityH2: "WhatsApp wasn't built for kids.",
    realityP: "Your child needs it to stay connected. You need sleep. Those two things collide every night.",
    pain1t: "Bullying & exclusion",
    pain1b: "Silent group removals and mean messages leave marks parents never see in time.",
    pain2t: "Threats & strangers",
    pain2b: "Unknown numbers and pressure tactics show up long before a kid knows how to react.",
    pain3t: "Inappropriate media",
    pain3b: "Images and videos arrive without warning — and disappear before anyone asks.",
    how: "How it works",
    howH2: "Set it once. Stay protected.",
    step1t: "Create your parent account",
    step1b: "Register and add your first child — 3-day free trial, no card needed.",
    step2t: "Scan the WhatsApp QR",
    step2b: "Start protection and link via Linked Devices — no Chromium browsers.",
    step3t: "Protection runs silently",
    step3b: "Incoming messages are scanned. You get alerts. Your child keeps chatting.",
    prot: "Protection",
    protH2: "Smart protection for parents — focused, simple, and clear.",
    f1t: "Threat & bullying alerts",
    f1b: "Parent phones get WhatsApp-style alerts when risky patterns appear.",
    f2t: "Privacy-first scanning",
    f2b: "Focus on incoming traffic. Optionally hide message bodies from alerts.",
    f3t: "₪15 per child. That's it.",
    f3b: "No plans, no tiers — every child is ₪15 for 30 days, all managed from one dashboard.",
    f4t: "Group exclusion signals",
    f4b: "Catch removals and social-exclusion patterns early.",
    f5t: "WhatsApp protection links",
    f5b: "Native multi-device protocol. QR + pairing code. No headless Chrome.",
    f6t: "Filters you control",
    f6b: "Ignore self-messages, block reports, media rules — tuned for real parenting.",
    ctaH2: "Protect your child in minutes.",
    ctaP: "First child free for 3 days. Then ₪15 per child for 30 days — half a shekel a day. Sleep a little better tonight.",
    startTrial: "Start free trial",
    viewPlans: "See pricing",
    pricing: "Pricing",
    pricingH2: "No headaches. Just ₪15 per child.",
    pricingP:
      "No plans, no tiers, no fine print. Every child — ₪15 for 30 days. That's half a shekel a day for peace of mind.",
    pricingPrice: "₪15",
    pricingUnit: "per child · per 30 days",
    pricingPerDay: "= ₪0.50 a day",
    pricingPoints: [
      "First child — 3-day free trial, no credit card",
      "Every additional child — ₪15 for 30 days, from day one",
      "Auto-renew or one-time payment — your call",
      "Cancel anytime. No commitment, no surprises",
    ],
    pricingCta: "Start with a free trial",
  },
  hero: {
    linked: "Linked device",
    protected: "Protected",
    group: "Group chat",
    groupD: "Exclusion pattern detected",
    unknown: "Unknown sender",
    unknownD: "Blocked before delivery",
    media: "Media message",
    mediaD: "Flagged · parent alerted",
    session: "Protection link",
    live: "Live · scanning incoming",
    parent: "Parent alert",
    parentD: "Bullying language blocked",
    child: "Child experience",
    childD: "Normal WhatsApp",
  },
  auth: {
    welcome: "Welcome back",
    loginLead: "Log in to manage protection sessions.",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    passwordMismatch: "Passwords do not match",
    signingIn: "Signing in...",
    login: "Log in",
    newHere: "New here?",
    createAccount: "Create an account",
    loginFailed: "Login failed",
    registerTitle: "Create your",
    registerParent: "parent",
    registerLead: "Then pick a plan and link your child's WhatsApp.",
    fullName: "Full name",
    phone: "Phone",
    creating: "Creating...",
    create: "Create account",
    haveAccount: "Already have an account?",
    registerFailed: "Registration failed",
    continueRegister: "Continue",
    sendingCode: "Sending code...",
    verifyEmailTitle: "Verify your email",
    verifyEmailLead: "We sent a code to",
    verificationCode: "Verification code",
    verifying: "Verifying...",
    confirmEmail: "Verify and create account",
    wrongEmailBack: "Wrong email? Back to registration",
    emailTaken: "Email already registered",
    mailNotConfigured: "Email is not configured on the server",
    codeSendFailed: "Could not send code",
    duplicateSend: "Already sent — wait a moment and try again",
    invalidCode: "Invalid code",
    codeExpired: "Code expired — start again",
    tooManyAttempts: "Too many attempts — try again later",
    verificationExpired: "Registration expired — start over",
    forgotPassword: "Forgot password",
    forgotTitle: "Reset password",
    forgotLeadEmail: "Enter the email you registered with. We'll send a verification code.",
    sendResetCode: "Send code",
    forgotCodeLead: "Enter the code we sent to your email.",
    noEmailAccess: "I don't have access to my registration email",
    parentPhoneLead: "Enter a parent phone number on your account. We'll send a WhatsApp code.",
    parentPhone: "Parent phone",
    sendParentCode: "Send WhatsApp code",
    parentCodeLead: "Enter the code sent to the parent's WhatsApp.",
    parentPhoneMismatch: "That phone doesn't match a parent on the account",
    invalidPhone: "Invalid phone number",
    reporterOffline: "Alert service is offline",
    backToEmailReset: "Back to email reset",
    backToLogin: "Back to log in",
    continue: "Continue",
    resetFailed: "Password reset failed",
    newPasswordTitle: "New password",
    newPasswordLead: "Choose a new password for your account.",
    newPassword: "New password",
    savingPassword: "Saving...",
    saveAndLogin: "Save and log in",
    resetSessionExpired: "Reset session expired — start forgot password again",
    loading: "Loading...",
  },
  billing: {
    tagline: "No headaches. Just ₪15 per child.",
    taglineSub: "No plans, no tiers, no fine print. Every child — ₪15 for 30 days. Half a shekel a day.",
    perChild: "₪15 per child",
    per30: "per 30 days",
    perDay: "₪0.50 / day",
    trialBadge: "First child — 3-day free trial",
    trialExplain:
      "The first child you add gets a 3-day free trial, no card needed. When the trial ends, protection pauses until you pay ₪15 for 30 days (₪0.50/day).",
    paidExplain:
      "Every additional child is charged ₪15 for 30 days right away — half a shekel a day. Choose auto-renew or a one-time payment.",
    addChildTitle: "Add a child",
    addFirstChildTitle: "Add your first child — free trial",
    childNameLabel: "Child's name (as shown in groups)",
    startTrialBtn: "Start 3-day free trial",
    payAndAdd: "Pay ₪15 & add child",
    payRenew: "Pay ₪15 for 30 days",
    payTitle: "Activate protection for {name}",
    summaryTitle: "Billing summary",
    lineChild: "Protection for {name} · 30 days",
    lineTotal: "Due today",
    autoRenewLabel: "Auto-renew every 30 days (₪15)",
    autoRenewHint: "Turn it off anytime. Without auto-renew, protection pauses after 30 days until the next payment.",
    oneTimeHint: "One-time payment: protection runs for 30 days and ends with no further charge.",
    cardName: "Name on card",
    cardNumber: "Card number",
    expiry: "Expiry (MM/YY)",
    cvc: "CVC",
    demoNote: "Demo gateway — any valid card works except numbers ending in 0000.",
    processing: "Processing…",
    cancel: "Cancel",
    stTrial: "Free trial · {days} days left",
    stTrialEnds: "When the trial ends ({date}) you'll need to pay ₪15 for 30 days to continue",
    stActive: "Protected until {date}",
    stActiveDays: "{days} days left",
    stAutoOn: "Auto-renew on — ₪15 will be charged on {date}",
    stAutoOff: "No auto-renew — protection pauses on {date}",
    stExpired: "Protection paused — period ended",
    stExpiredHint: "{name}'s messages aren't scanned and no alerts are sent until payment is made.",
    stNone: "No active protection period",
    payNowBtn: "Pay ₪15",
    extendBtn: "Extend 30 days (₪15)",
    autoOn: "Turn on auto-renew",
    autoOff: "Turn off auto-renew",
    sectionTitle: "Billing & payments",
    sectionLead: "₪15 per child for 30 days. Half a shekel a day. No headaches.",
    activeChildren: "Protected children",
    monthlyTotal: "Total per 30 days",
    cardOnFile: "Card on file",
    noCard: "No card on file",
    renewalFailed: "Last renewal failed — pay manually to update your card",
    historyTitle: "Payment history",
    historyEmpty: "No payments yet",
    hDate: "Date",
    hChild: "Child",
    hDesc: "Details",
    hPeriod: "Period",
    hAmount: "Amount",
    hStatus: "Status",
    hOrder: "Order ID",
    kindTrial: "Free trial (3 days)",
    kindPurchase: "Child added · 30 days",
    kindRenewal: "Renewal · 30 days",
    statusOk: "Succeeded",
    statusDeclined: "Declined",
    errCard: "Invalid card number",
    errExpiry: "Invalid expiry (MM/YY)",
    errExpired: "Card has expired",
    errDeclined: "Card declined (demo: any number not ending in 0000)",
    errNoCard: "No card on file — pay once to save a card",
    errTrialUsed: "Trial already used — adding a child costs ₪15",
    errPaymentRequired: "Payment is required to activate protection for this child",
    errGeneric: "Something went wrong — try again",
    headerChip: "{n} protected children · ₪15 per child",
    headerChipNone: "₪15 per child · first child free for 3 days",
    attention: "{n} children awaiting payment — their protection is paused",
  },
  legal: {
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    accessibility: "Accessibility Statement",
    back: "Back",
    updated: "Last updated: {date}",
    toc: "Contents",
    print: "Print",
  },
  dash: {
    signedIn: "Signed in as {email}",
    hey: "Hey {name}",
    billingUnavailable: "Could not load your billing status — try refreshing",
    children: "Children",
    childPlaceholder: "Child display name (as in groups)",
    addChild: "Add child",
    editChildName: "Edit name",
    saveChildName: "Save",
    renameFail: "Could not update name",
    noChildren: "No children yet. Add your first child — 3-day free trial — then link WhatsApp with QR.",
    on: "Protection on",
    linkedPaused: "Linked · protection paused",
    noNumber: "Number unavailable — Start protection",
    waitingScan: "Waiting for WhatsApp scan…",
    notLinked: "Not linked",
    pause: "Pause",
    start: "Start protection",
    unlink: "Unlink",
    cancelPair: "Cancel pairing",
    linkWa: "Link WhatsApp",
    mockQr: "MOCK QR — not scannable by real WhatsApp.",
    qrHint: "WhatsApp → Linked Devices → Link a Device",
    waitingQr: "Waiting for QR…",
    mockScan: "Dev: simulate scan",
    orCode: "Or use pairing code",
    phonePh: "Child phone E.164",
    getCode: "Get code",
    settings: "Protection settings",
    settingsLead:
      "Choose which events and content types are sent to verified parents on WhatsApp. All options are on by default—turn off only what you do not want.",
    secBlock: "Block list reports",
    secBlockDesc: "Alerts when your child blocks or unblocks a WhatsApp contact.",
    reportBlock: "Report when a user is blocked",
    reportUnblock: "Report when a block is removed",
    secGroups: "Reports from groups",
    secGroupsDesc: "Group membership events and harmful group messages that quote or mention your child.",
    reportGroupRemoval: "Report removal from a group",
    reportGroupJoin: "Report joining a group",
    reportGroupHarmful:
      "Report harmful group messages when your child is quoted or mentioned",
    secPrivate: "Private chat reports",
    secPrivateDesc: "Alerts for activity from numbers not saved in your child's contacts.",
    reportUnknownContact:
      "Report messages from unknown phone numbers — only the 1st and 2nd message in the chat",
    secGeneral: "General reports",
    secGeneralDesc: "Filter by media type, alert privacy, and outgoing messages from your child.",
    mediaTypes: "Message types to report",
    reportMediaImages: "Images",
    reportMediaVideos: "Videos",
    reportMediaAudio: "Voice recordings",
    reportMediaText: "Text messages",
    reportMediaStickers: "Stickers",
    privacyMode: "Content in alerts",
    privacyShowContent: "Show reported message content",
    privacyHideContent: "Protect privacy — type of message and content category only",
    privacyHideHint:
      "In privacy mode, alerts omit quotes, images, and audio; you receive a general description of the event.",
    reportOutgoing: "Report harmful outgoing messages your child sent",
    reportOutgoingHint: "Applies to inappropriate content your child sends, for the media types enabled above.",
    addFail: "Failed to add child",
    startFail: "Failed to start",
    unlinkConfirm: "Unlink WhatsApp? This removes the device from WhatsApp Linked Devices.",
    unlinkFail: "Unlink failed — WhatsApp device was NOT removed",
    deleteLinked: "Delete this child? WhatsApp will be unlinked from Linked Devices first.",
    deletePlain: "Delete this child from ChatiSafe?",
    deleteFail: "Delete failed",
    pairFail: "Pairing failed",
    qrFail: "QR failed — click Start again",
    parents: "Parents",
    parentsLead: "Add a parent who receives WhatsApp alerts about harmful messages. Phone verification is required before linking children.",
    addParent: "Add parent",
    parentName: "Parent name",
    parentPhone: "Phone number",
    parentCountry: "Country",
    parentSendCode: "Send verification code",
    parentVerifyLead: "We sent a code on WhatsApp. Enter it here to confirm this number.",
    parentCode: "Verification code",
    parentConfirm: "Confirm & add",
    parentResend: "Resend",
    parentRemove: "Remove",
    parentRemoveConfirm: "Remove this parent from alert recipients?",
    parentInvalidPhone: "Invalid phone number.",
    parentNotOnWa: "This number is not registered on WhatsApp.",
    parentReporterOffline: "Alert service is offline — try again later.",
    parentAlready: "This number is already on your list.",
    parentWrongCode: "Wrong code.",
    parentCodeExpired: "Code expired — request a new one.",
    parentSendFail: "Could not send verification code.",
    parentGenericFail: "Something went wrong.",
    parentServerError: "Server error — please try again in a moment.",
    parentWaCheckFail: "Could not verify WhatsApp registration. Ensure Reporter is connected.",
    parentWaServiceOutdated: "Alert service is temporarily unavailable. Please try again later.",
    parentNoPending: "No active verification — send a new code.",
    parentTooManyAttempts: "Too many attempts — request a new code.",
    childrenLocked: "Add and verify at least one parent before managing children.",
  },
  admin: {
    title: "Admin",
    password: "Admin password",
    enter: "Enter",
    wrong: "Wrong password",
    users: "Users",
    payments: "Payments",
    sessions: "Sessions",
    logout: "Log out",
    all: "All",
    paying: "Paying",
    notPaying: "Not paying",
    noUsers: "No users",
    noSessions: "No sessions",
    noPayments: "No paying users",
    name: "Name",
    email: "Email",
    phone: "Phone",
    plan: "Plan",
    none: "None",
    child: "Child",
    session: "Session",
    waPhone: "Connected number",
    notConnected: "Not connected",
    running: "Running",
    stopped: "Stopped",
    connected: "Connected",
    owner: "Owner",
    registered: "Registered",
    expires: "Expires",
    count: "{n} users",
  },
};

export type Dict = typeof en;
export const dictionaries: Record<Locale, Dict> = { he: he as Dict, en };

export function interpolate(template: string, vars: Record<string, string | number>) {
  return template.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? ""));
}
